/**
 * Use this in the default case of switch statements to ensure that you have covered
 * all cases. If not, typescript will give a compile-time error.
 *
 * @param _x The value you are switching over.
 */
export function assertUnreachable(_x: never): never {
	throw new Error("Unreachable");
}
